import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { useLanguage } from '../../context/LanguageContext';
import { useEscaCopy } from '../../i18n/escaCopy';
import { clientLogos } from '../../data/clientLogos';
const EASE = [0.23, 1, 0.32, 1] as const;
export function ProofSection() {
  const {
    lang
  } = useLanguage();
  const c = useEscaCopy(lang);
  const ref = useRef<HTMLDivElement>(null);
  const inView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section className="bg-white py-20 lg:py-28" ref={ref} data-id="element-445" data-mp="1wu3otfch1vts">
      <div className="max-w-[88rem] mx-auto px-5 sm:px-8" data-id="element-446" data-mp="1wsiw7v9pwmyk">
        <motion.h2 initial={{
        opacity: 0,
        y: 16
      }} animate={inView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.55,
        ease: EASE
      }} className="esca-h2 text-ink max-w-[22ch] text-balance" data-id="element-447" data-mp="1rtzbfy6v1h7s">
          {c.proof.title}
        </motion.h2>

        <dl className="mt-14 lg:mt-16 grid grid-cols-2 lg:grid-cols-5 gap-x-6 gap-y-10 border-t border-line pt-10" data-id="element-448" data-mp="3i6x2mjuinehq">
          {c.proof.stats.map((s, i) => <motion.div key={s.label} initial={{
          opacity: 0,
          y: 14
        }} animate={inView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.5,
          delay: 0.08 + i * 0.06,
          ease: EASE
        }} data-id="element-449" data-mp="2xxu8x120mx0t" data-mpi={i}>
              <dt className="font-display text-[2.25rem] lg:text-[3rem] font-bold text-ink tracking-[-0.045em] leading-none" data-id="element-450" data-mp="3glz9y0rag3vx">
                {s.value}
              </dt>
              <dd className="mt-3 text-[0.875rem] text-muted leading-snug" data-id="element-451" data-mp="3ln6e7pu82kxu">
                {s.label}
              </dd>
            </motion.div>)}
        </dl>

        {/* Client logos — monochrome, colour on hover */}
        <div className="mt-20 lg:mt-24" data-id="element-452" data-mp="3fpc3qq0mmn8">
          <p className="esca-eyebrow text-muted" data-id="element-453" data-mp="3enpqq3judq7">{c.proof.logosTitle}</p>
          <motion.ul initial={{
          opacity: 0
        }} animate={inView ? {
          opacity: 1
        } : {}} transition={{
          duration: 0.6,
          delay: 0.2,
          ease: EASE
        }} className="mt-8 grid grid-cols-3 sm:grid-cols-4 lg:grid-cols-5 border-t border-l border-line" data-id="element-454" data-mp="86p5ilzxemkz">
            {clientLogos.map(logo => <li key={logo.name} className={`group flex items-center justify-center h-24 lg:h-28 px-6 border-r border-b border-line ${logo.bgClass === 'bg-navy-900' ? 'bg-ink' : 'bg-white'}`} data-id="element-455" data-mp="8zwn17h53v3g">
                <img src={logo.logo} alt={logo.name} loading="lazy" className="max-h-9 lg:max-h-11 w-auto object-contain grayscale opacity-55 transition-[filter,opacity] duration-200 ease-out group-hover:grayscale-0 group-hover:opacity-100" data-id="element-456" data-mp="3qgwl7ypuwnfc" />
              </li>)}
          </motion.ul>
        </div>

        {/* Client quotes */}
        <div className="mt-20 lg:mt-24" data-id="element-457" data-mp="37jveo9gnmf9a">
          <p className="esca-eyebrow text-muted" data-id="element-458" data-mp="2xfeytg36cy5h">{c.proof.quotesTitle}</p>
          <div className="mt-8 grid lg:grid-cols-3 gap-8 lg:gap-12 border-t border-line pt-10" data-id="element-459" data-mp="2xhj2bwx5vv58">
            {c.proof.quotes.map((q, i) => <motion.figure key={q.author} initial={{
            opacity: 0,
            y: 14
          }} animate={inView ? {
            opacity: 1,
            y: 0
          } : {}} transition={{
            duration: 0.5,
            delay: 0.25 + i * 0.07,
            ease: EASE
          }} className="flex flex-col" data-id="element-460" data-mp="37d2xui7tcrtg" data-mpi={i}>
                <blockquote className="text-[1.0625rem] text-ink leading-relaxed" data-id="element-461" data-mp="2ombfws9rft3g">
                  {q.quote}
                </blockquote>
                <figcaption className="mt-auto pt-5 text-[0.8125rem] text-muted" data-id="element-462" data-mp="2tf4k9f1bgzf0">
                  {q.author}
                </figcaption>
              </motion.figure>)}
          </div>
        </div>
      </div>
    </section>;
}